function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Defs, Rect, G, Mask, Use, Text, TSpan } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Rect, {
  id: "icon-hd-full_svg__a",
  width: 61,
  height: 61,
  x: 0,
  y: 0,
  rx: 10
}));

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Mask, {
  id: "icon-hd-full_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#icon-hd-full_svg__a"
})), /*#__PURE__*/React.createElement(Use, {
  fill: "#00245A",
  xlinkHref: "#icon-hd-full_svg__a"
}), /*#__PURE__*/React.createElement(G, {
  mask: "url(#icon-hd-full_svg__b)"
}, /*#__PURE__*/React.createElement(Text, {
  fontFamily: "Gotham-Medium, Gotham",
  fontSize: 20,
  fontWeight: 400,
  letterSpacing: 0.777,
  transform: "translate(16 19)"
}, /*#__PURE__*/React.createElement(TSpan, {
  x: 0,
  y: 25,
  fill: "#17BF88"
}, "HD")), /*#__PURE__*/React.createElement(Text, {
  fontFamily: "Gotham-Light, Gotham",
  fontSize: 10,
  fontWeight: 300,
  letterSpacing: 0.389,
  transform: "translate(16 19)"
}, /*#__PURE__*/React.createElement(TSpan, {
  x: 0,
  y: 8,
  fill: "#17BF88"
}, "Full"))));

function SvgIconHdFull(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 61
  }, props), _ref, _ref2);
}

export default SvgIconHdFull;